 const BaseUrl = "https://assetsapi.meander.software/"
 export default BaseUrl
